module.exports = __webpack_public_path__ + "static/img/9bg_5.e01a5ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/9bg_5.png
// module id = 777
// module chunks = 1